module.exports = __webpack_public_path__ + "static/media/valo.9f018b5b.png";